import { Carousel } from "react-bootstrap";
import c1 from "../../images/Car/c2.jpg";

import c3 from "../../images/Car/robot.jpg";

import c5 from "../../images/Car/c1.jpg"

export default function ImageCarousel() {
  const imgStyle = {
    height: "550px", 
    Width: "550px",
    objectFit: "cover",
    borderRadius: "15px",
 
  };

  return (
    <Carousel fade interval={5000}>
      <Carousel.Item>
        <img
          className="d-block "
          src={c1}
          alt="First slide"
          style={imgStyle}
        />
      </Carousel.Item>

      <Carousel.Item>
        <img
          className="d-block"
          src={c5}
          alt="Second slide"
          style={imgStyle}
        />
      </Carousel.Item>

      <Carousel.Item>
        <img
          className="d-block "
          src={c3}
          alt="Third slide"
          style={imgStyle}
        />
      </Carousel.Item>
    </Carousel>
  );
}
